import { PRESET } from "../api"

/**
 * Dictionary of all the preset screens in the app.
 * The key is the name of the preset and the value is a function that returns the page‘s loader.
 */
export const ScreenByPreset = {
  [PRESET.FACE]: () => import("@/features/presets/face").then(({ default: screen }) => screen),
  [PRESET.FACE_180]: () =>
    import("@/features/presets/face-180").then(({ default: screen }) => screen),
  [PRESET.HAIR]: () => import("@/features/presets/hair").then(({ default: screen }) => screen),
}

export type PresetScreen = Awaited<ReturnType<PresetScreenLoader>>
export type PresetScreenLoader = (typeof ScreenByPreset)[keyof typeof ScreenByPreset]

export const loadScreenByPreset = async (preset: PRESET) => {
  return await ScreenByPreset[preset]()
}
